/**
 * Canonical paths + URL aliases — keep in sync with App.js route detection & SiteHeader submenu order.
 */
export const SERVICE_SUBNAV_ITEMS = [
  { navKey: "mechanics", path: "/mecanica-revizii", aliases: ["/mecanica"] },
  { navKey: "diagnostics", path: "/diagnoza-computerizata", aliases: ["/diagnoza"] },
  { navKey: "paint", path: "/vopsitorie-auto", aliases: ["/vopsitorie"] },
  { navKey: "pilkington", path: "/parbrize-pilkington", aliases: ["/pilkington"] },
  { navKey: "climate", path: "/climatizare-auto", aliases: ["/climatizare"] },
  { navKey: "claims", path: "/constatari-daune", aliases: ["/daune-auto"] },
  { navKey: "oils", path: "/uleiuri-consultanta", aliases: ["/uleiuri-auto"] },
  { navKey: "itp", path: "/itp-auto-camioane", aliases: ["/itp"] },
  { navKey: "tachograph", path: "/verificare-tahograf", aliases: ["/tahograf"] },
];

/** Subentries under „Servicii” — excludes items linked directly from the main bar */
export const SERVICE_SUBMENU_ITEMS = SERVICE_SUBNAV_ITEMS.filter((i) => i.navKey !== "claims");

export function serviceSubNavItemIsActive(pathname, item) {
  const p = pathname || "";
  if (p === item.path) return true;
  return Array.isArray(item.aliases) && item.aliases.includes(p);
}

/** Index curent în lista circulară sau -1 dacă nu e pagină serviciu. */
export function serviceSubNavActiveIndex(pathname) {
  return SERVICE_SUBNAV_ITEMS.findIndex((item) => serviceSubNavItemIsActive(pathname, item));
}

/** Serviciul anterior / următor (indecși circulari). */
export function getAdjacentServices(pathname) {
  const idx = serviceSubNavActiveIndex(pathname);
  if (idx < 0) return null;
  const n = SERVICE_SUBNAV_ITEMS.length;
  const prev = SERVICE_SUBNAV_ITEMS[(idx - 1 + n) % n];
  const next = SERVICE_SUBNAV_ITEMS[(idx + 1) % n];
  const current = SERVICE_SUBNAV_ITEMS[idx];
  return { prev, next, current };
}
